import type { Option } from '../GenericBloc/GenericRadioFilter/GenericRadioDropdown';
import { NEW_RETURNING_USER_TYPE } from './NewReturningUserFilterType';

export const OPTION_LIST: Option<NEW_RETURNING_USER_TYPE>[] = [
  { value: NEW_RETURNING_USER_TYPE.NEW, label: 'New users' },
  { value: NEW_RETURNING_USER_TYPE.RETURNING, label: 'Returning users' },
];
